/**
 * Парсит строку времени формата HH:MM:SS или MM:SS или SS в секунды
 * @param timeString - строка времени
 * @returns число секунд или null если формат некорректный
 */
export function parseTimeFromString(timeString: string): number | null {
    const trimmed = timeString.trim();

    if (!trimmed) {
        return null;
    }

    const parts = trimmed.split(':').map((part) => part.trim());

    for (const part of parts) {
        if (!/^\d+$/.test(part)) {
            return null;
        }
    }

    const numbers = parts.map(Number);

    if (numbers.length === 1) {
        return numbers[0];
    } else if (numbers.length === 2) {
        const [minutes, seconds] = numbers;
        if (seconds >= 60) {
            return null;
        }
        return minutes * 60 + seconds;
    } else if (numbers.length === 3) {
        const [hours, minutes, seconds] = numbers;
        if (minutes >= 60 || seconds >= 60) {
            return null;
        }
        return hours * 3600 + minutes * 60 + seconds;
    }

    return null;
}
